import { Instagram } from "lucide-react";
import { motion } from "framer-motion";
import { scrollToId } from "./shared";

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-stone-200/80 bg-white/70 backdrop-blur-xl"
      data-testid="navbar"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6">
        <button
          onClick={() => scrollToId("#hero")}
          className="flex flex-col items-start leading-none"
          data-testid="nav-logo"
          aria-label="BeanGo Cube X — zpět na začátek"
        >
          <span className="font-display text-lg font-black uppercase tracking-tight text-stone-900">
            BeanGo Cube<span className="text-gold">®</span> X
          </span>
          <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-stone-400">
            Výhradní dovozce ČR · SR
          </span>
        </button>

        <div className="flex items-center gap-3">
          <a
            href="https://instagram.com/beangocube_cz_sk"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram @beangocube_cz_sk"
            className="flex items-center gap-2 rounded-full border border-stone-300 px-3.5 py-2 text-stone-500 transition-colors duration-300 hover:border-stone-900 hover:text-stone-900"
            data-testid="nav-instagram-link"
          >
            <Instagram className="h-4 w-4" />
            <span className="hidden text-xs font-bold sm:inline">@beangocube_cz_sk</span>
          </a>
          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            onClick={() => scrollToId("#form")}
            className="rounded-full bg-stone-900 px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-stone-700"
            data-testid="nav-cta-button"
          >
            Chci nabídku
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
}
